import { BigNumber } from "../../classes/BigNumber";
import { iChrItem, tDiscountPercent } from "../../interfaces";
import { itemIds } from "../../settings";
import { store } from "../../store/store";
import { getGtxClient } from "./getGtxClient";

export const getAllAssetsQuery = async () => {
	const response = await (await getGtxClient()).query("ft4.get_all_assets", { page_size: 100, page_cursor: null });

	console.log('ft4.get_all_assets: ', response.data.map(asset => { return {...asset, id: asset.id.toString('hex')}}));

	const res = response.data.map(asset => { return {
		...asset,
		id: asset.id.toString('hex'),

	}});
	return res;
}

// export const getAssetBallancesQuery = async (assetId: string) => {
export const getAssetBallancesQuery = async () => {
	const { chrClientAddr } = store.getState().chromia;
	if (!chrClientAddr) throw new Error();

	// const response = await (await getGtxClient()).query("ft4.get_asset_balances", { account_id: chrClientAddr, asset_id: assetId });
	const response = await (await getGtxClient()).query("ft4.get_asset_balances", { account_id: chrClientAddr,  page_size: 100, page_cursor: null});

	const res = response.data.map(balance => { return {
		amount: +new BigNumber(balance.amount.toString(), {decimals: balance.asset.decimals, currentDecimals: balance.asset.decimals}).valueStr,
		asset: {
			...balance.asset,
			id: balance.asset.id.toString('hex')
		}
	}});

	console.log('ft4.get_asset_balances: ', res);

	return res;
}

export const getAssetBallanceQuery = async (assetId: string) => {
	const { chrClientAddr } = store.getState().chromia;
	if (!chrClientAddr) throw new Error();

	const response = await (await getGtxClient()).query("ft4.get_asset_balance", { account_id: chrClientAddr, asset_id: assetId });

	if (!response) throw new Error();

	const res = {
		amount: new BigNumber(response.amount.toString(), {decimals: response.asset.decimals, currentDecimals: response.asset.decimals}).valueStr,
		asset: {
			...response.asset,
			id: response.asset.id.toString('hex')
		}
	};

	console.log('ft4.get_asset_balance: ', res);

	return res;
}

export const getAllPeriodsQuery = async () => {
	const { discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe.GetAllPeriods", {item_id: itemIds[discountPercent]});

	// console.log('pickaxe.GetAllPeriods: ', res);
	return res;
}

export const getAllLaunchesQuery = async () => {
	const { discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe.GetAllLaunchs", {item_id: itemIds[discountPercent]});

	// console.log('pickaxe.GetAllLaunchs: ', res);
	return res;
}

export const getAllDeposQuery = async () => {
	const { discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe.GetAllDepos", {item_id: itemIds[discountPercent]});

	// console.log('pickaxe.GetAllDepos: ', res);
	return res;
}

export const getClientDeposQuery = async (address: string) => {
	const { discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe.GetClientDepos", {item_id: itemIds[discountPercent], from: address});

	// console.log('pickaxe.GetClientDepos from ',address, ', item: ', itemIds[discountPercent], ': ', res);
	return res;
}

/* export const getLaunchByPeriodIdQuery = async (periodId: number) => {
	const res = await (await getGtxClient()).query("pickaxe.GetLaunchByPeriodId", {per_id: periodId});

	console.log('pickaxe.GetLaunchByPeriodId: ', res);
	return res;
} */

export const getItems = async (): Promise<iChrItem[]> => {
	const response = await (await getGtxClient()).query("pickaxe.GetItems", {});
	// const acc = res.acc.toString('hex');
	// console.log('pickaxe.getParams: ', res, '\nacc: ', acc, acc.length, !!acc);
	const res = response.map(item => { return {
		...item,
		acc: item.acc.toString('hex'),
		ft: item.ft.toString('hex'),
		ut: item.ut.toString('hex'),
		owner: item.owner.toString('hex'),
		price_pool: item.price_pool.toString('hex'),
		min_depo: new BigNumber(item.min_depo),
		discount_ut: new BigNumber(item.discount_ut),
	}});
	// console.log('pickaxe.getItems: ', res);
	return res;
}

export const getItem = async (percent?: tDiscountPercent) => {
	const { discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe.GetItem", {item_id: itemIds[percent || discountPercent]});
	// const acc = res.acc.toString('hex');
	// console.log('pickaxe.getParams: ', res, '\nacc: ', acc, acc.length, !!acc);
	// console.log('pickaxe.getItem: ', res);
	return res;
}

export const getTimeQuery = async () => {
	const res = await (await getGtxClient()).query('pickaxe.GetTime', {});

	// console.log('pickaxe.GetTime: ', res);
	// return Math.floor(res/1000);
	return res;
}

export const getInWorkQuery = async () => {
	const { discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query('pickaxe.GetInWork', {item_id: itemIds[discountPercent]});
	
	// console.log('pickaxe.GetInWork: ', res);
	return res;
}

export const getStateQuery = async (itemId?: string) => {
	const { discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query('pickaxe.GetState', {item_id: itemId || itemIds[discountPercent]});

	// console.log('pickaxe.GetState: ', res);
	return res;
}


export const getDexTime = async () => {
	const res = await (await getGtxClient()).query('slurpyswap.GetTime', {});
	
	// console.log('slurpyswap.GetTime: ', res);
	// return Math.floor(res/1000);
	return res;
}
export const getEoptTime = async () => {
	const res = await (await getGtxClient()).query('hedget.GetTime', {});
	
	// console.log('hedget.GetTime: ', res);
	// return Math.floor(res/1000);
	return res;
}